import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SabisArrowIconComponent } from './arrow-icon.component';
import { SabisDownArrowIconComponent } from './down-arrow-icon.component';
import { SabisNgxXIconComponent } from './x-icon.component';



@NgModule({
  declarations: [
    SabisNgxXIconComponent,
    SabisArrowIconComponent,
    SabisDownArrowIconComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    SabisNgxXIconComponent,
    SabisArrowIconComponent,
    SabisDownArrowIconComponent
  ]
})
export class SabisNgxIconsModule { }
